module.exports = __webpack_public_path__ + "assets/img/3_1294.69001335.jpg";